// extracted by mini-css-extract-plugin
export var button = "styles-module--button--5dAv1";
export var transparent = "styles-module--transparent--yxSXZ";
export var secondary = "styles-module--secondary--EWIx+";